export default __webpack_public_path__ + "static/img-app-leaderboard-3b86049d4480dab4f1e880e7b281808b.jpg";